import { useState } from "react";
import { toast } from "sonner";
import { Upload, Loader2 } from "lucide-react";
import api, { formatApiError, imgSrc } from "../lib/api";

const inputCls =
  "w-full rounded-lg border border-white/10 bg-white/[0.04] px-4 py-2.5 text-sm text-slate-100 placeholder:text-slate-500 outline-none focus:border-gold/60 transition-colors";

const ImageUpload = ({ value, onChange, testid, placeholder = "Image URL or upload" }) => {
  const [uploading, setUploading] = useState(false);

  const pick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    setUploading(true);
    try {
      const { data } = await api.post("/admin/upload", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      onChange(data.url);
      toast.success("Image uploaded");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setUploading(false);
      e.target.value = "";
    }
  };

  return (
    <div className="space-y-2.5" data-testid={testid}>
      <div className="flex gap-2.5">
        <input
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          data-testid={`${testid}-input`}
          className={inputCls}
        />
        <label
          data-testid={`${testid}-upload-btn`}
          className="shrink-0 cursor-pointer inline-flex items-center gap-2 rounded-lg border border-gold/40 bg-gold/10 px-4 text-xs font-bold tracking-wider text-gold font-display hover:bg-gold/20 transition-colors"
        >
          {uploading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />}
          {uploading ? "UPLOADING" : "UPLOAD"}
          <input type="file" accept="image/jpeg,image/png,image/webp,image/gif" className="hidden" onChange={pick} disabled={uploading} />
        </label>
      </div>
      {value && (
        <img
          src={imgSrc(value)}
          alt="preview"
          data-testid={`${testid}-preview`}
          className="h-20 w-32 object-cover rounded-lg border border-white/10"
          onError={(e) => (e.currentTarget.style.display = "none")}
        />
      )}
    </div>
  );
};

export default ImageUpload;
